import React, {Component} from "react";
import "./PriceItem.css";
import SiteService from "../service/SiteService";
import logger from "../common/Logger";

class PriceItem extends Component {
    render() {
        const features = this.buildFeatures();

        return (
            <div
                className={`${typeof this.props.limitColumns !== 'undefined' ? 'col-sm-' + this.props.limitColumns : '' } ${typeof this.props.offsetColumns !== 'undefined' ? 'col-sm-offset-' + this.props.offsetColumns : '' } ${ this.props.xPadding ? 'p-x' : '' } ${ this.props.yPadding ? 'm-b-lg' : '' }`}>

                {this.props.headerVisible &&
                <div className="p-x">
                    <h6 className="text-muted text-uppercase m-b">{this.props.title}</h6>

                    {this.props.price !== "0" &&
                    <div className="price-container">
                        <span className="price-currency">&pound;</span>
                        <span className="price-amount">{this.props.price}</span>
                        <span className="price-period"> /MO</span>
                    </div>}

                    {this.props.price === "0" &&
                    <div className="price-container">
                        <span className="price-free">Free</span>
                    </div>}

                    <p>{this.props.description}</p>
                </div>}

                {this.props.featuresVisible &&
                <ul className={`list-unstyled ${this.props.featureSpacersVisible ? 'list-bordered m-y-md' : ''} text-left`}>
                    {features}
                </ul>}

                <button className={`btn btn-lg btn-${this.props.buttonStyle} btn-block`} onClick={this.props.onClick}
                        style={{visibility: this.props.buttonVisible ? 'visible' : 'hidden'}}>
                    {this.props.buttonText}
                </button>
            </div>
        );
    }

    /**
     * Build an array of feature list items.
     *
     * @returns {Array}
     */
    buildFeatures() {
        const features = [];
        let priceItemClassName = `price-item ${this.props.featureSpacersVisible ? 'p-y' : 'p-t-sm'}`;
        let key = 0;

        if (SiteService.isMocksSite()) {
            let mockFeatures = [];
            switch (this.props.title.toLowerCase()) {
                case 'starter':
                    mockFeatures.push(<div key={key++}><i className="m-r-xs icon icon-check"/><strong>HTTPS</strong> enabled by default</div>);
                    mockFeatures.push(<div key={key++}><i className="m-r-xs icon icon-check"/><strong>2</strong> mock APIs</div>);
                    mockFeatures.push(<div key={key++} className="text-muted"><i className="m-r-xs icon icon-cross"/>no logs</div>);
                    mockFeatures.push(<div key={key++} className="text-muted"><i className="m-r-xs icon icon-cross"/>no scripted responses</div>);
                    break;

                case 'individual':
                    mockFeatures.push(<div key={key++}><i className="m-r-xs icon icon-check"/><strong>HTTPS</strong> enabled by default</div>);
                    mockFeatures.push(<div key={key++}><i className="m-r-xs icon icon-check"/><strong>20</strong> mock APIs</div>);
                    mockFeatures.push(<div key={key++}><i className="m-r-xs icon icon-check"/><strong>real time</strong> logs</div>);
                    mockFeatures.push(<div key={key++}><i className="m-r-xs icon icon-check"/><strong>dynamic</strong> scripted responses</div>);
                    break;

                case 'enterprise':
                    mockFeatures.push(<div key={key++}><i className="m-r-xs icon icon-check"/><strong>HTTPS</strong> enabled by default</div>);
                    mockFeatures.push(<div key={key++}><i className="m-r-xs icon icon-check"/><strong>1,000</strong> mock APIs</div>);
                    mockFeatures.push(<div key={key++}><i className="m-r-xs icon icon-check"/><strong>real time</strong> logs</div>);
                    mockFeatures.push(<div key={key++}><i className="m-r-xs icon icon-check"/><strong>dynamic</strong> scripted responses</div>);
                    break;

                default:
                    logger.warn(`Unsupported price tier: ${this.props.title}`);
                    break;
            }
            features.push(<li key={key++} className={priceItemClassName}>{mockFeatures}</li>);

        } else if (SiteService.isBotSite()) {
            let botFeatures = [];
            for (let feature of this.props.features) {
                botFeatures.push(<div key={key++}><i className="m-r-xs icon icon-check"/>{feature}</div>);
            }
            features.push(<li key={key++} className={priceItemClassName}>{botFeatures}</li>);
        }

        return features;
    }
}

PriceItem.propTypes = {
    title: React.PropTypes.any,
    description: React.PropTypes.any,
    price: React.PropTypes.string,
    headerVisible: React.PropTypes.bool,
    features: React.PropTypes.arrayOf(React.PropTypes.element),
    featuresVisible: React.PropTypes.bool,
    featureSpacersVisible: React.PropTypes.bool,
    buttonVisible: React.PropTypes.bool,
    buttonText: React.PropTypes.any,
    buttonStyle: React.PropTypes.string,
    limitColumns: React.PropTypes.number,
    offsetColumns: React.PropTypes.number,
    onClick: React.PropTypes.func,
    xPadding: React.PropTypes.bool,
    yPadding: React.PropTypes.bool
};

PriceItem.defaultProps = {
    title: '',
    description: '',
    headerVisible: true,
    features: [],
    featuresVisible: true,
    featureBordersVisible: true,
    buttonVisible: true,
    buttonText: '',
    buttonStyle: 'primary',
    limitColumns: undefined,
    offsetColumns: undefined,
    xPadding: true,
    yPadding: true
};

export default PriceItem;



// WEBPACK FOOTER //
// ./src/modules/common/PriceItem.js